import React from 'react'
import { withRouter } from 'src/lib/router/with_router'

const ErrorPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.errorCode}>404</div>
      <div style={styles.message}>
        <h2>Pagina non trovata</h2>
        <p>Oops! Sembra che tu sia finito su una pagina che non esiste.</p>
      </div>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f7f7f7',
    textAlign: 'center',
  },
  errorCode: {
    fontSize: '120px',
    fontWeight: 'bold',
    color: '#e74c3c',
  },
  message: {
    fontSize: '18px',
    color: '#555',
  },
  link: {
    fontSize: '16px',
    color: '#3498db',
    textDecoration: 'none',
    marginTop: '20px',
  },
}

export default withRouter(ErrorPage)
